const data = [
  {
    id: 1,
    image: "./images/1.png",
    name: "Campground Rent App",
    description:
      "Using Node, Express Js and MongoDB I built this full CRUD application for users to rent campgrounds across the world. Users can safely register, login, post new campgrounds, upload images, edit existing ones and also give reviews. It uses mongo relations. Implement authentication and authorizations. It also includes a map using Mapbox API.",
    tags: ["Mongo", "Express", "EJS", "Node"],
    code: "https://github.com/Samaresh-Das/Yelp-Camp.git",
    live: "https://sammy-camp.cyclic.app/",
  },
  {
    id: 2,
    image: "/images/6.png",
    name: "Sam's Tech Store",
    description:
      "It uses Next Js, Context API, Sanity(for CMS), React-Icons, CSS. An e-commerce site for tech related stuffs with cart functionality. All the item data come from Sanity Content Management System",
    tags: ["Next JS", "React-Icons", "Sanity IO", "CSS"],
    code: "https://github.com/Samaresh-Das/Sam-s-Tech-Store-Eccomerce",
    live: "https://sam-s-tech-store.netlify.app/",
  },
  {
    id: 3,
    image: "/images/5.png",
    name: "Sam's Shop",
    description:
      "A shopping e-commerce page with cart functionality. Users can toggle between dark mode, change the view style of items.",
    tags: ["React/Redux", "Context API", "React-Icons", "Bootstrap", "CSS"],
    code: "https://github.com/Samaresh-Das/My-Shop-React.git",
    live: "https://sams-cloth-store.netlify.app/",
  },
  {
    id: 4,
    image: "/images/2.png",
    name: "Bank Website",
    description:
      "A static website built using React Js and Tailwind CSS using modern UI/UX design",
    tags: ["React", "Tailwind CSS"],
    code: "https://github.com/Samaresh-Das/Bank-React.git",
    live: "https://sam-dev-bank.pages.dev/",
  },
  {
    id: 5,
    image: "/images/7.png",
    name: "Firebase Authentication React Form",
    description:
      "In this app firebase is used for authenticating users using google or normal email password. It is built with vite react and tailwind css.",
    tags: ["React Js", "Firebase Auth", "OAuth", "Tailwind"],
    code: "https://github.com/Samaresh-Das/firebase-auth.git",
    live: "https://firebaseauth-breezeai.netlify.app/",
  },
  {
    id: 6,
    image: "/images/3.png",
    name: "React To-Do List",
    description:
      "It simply uses React Js to make a to-do list. This app is not connected to any database though. ",
    tags: ["React Js"],
    code: "https://github.com/Samaresh-Das/React-Todo-list.git",
    live: "https://react-todo-list-dlh.pages.dev/",
  },
];

export default data;
